import React from 'react'

export const Loader: React.FC = () => (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/30">
    <div
      className="h-[60px] w-[60px] animate-spin rounded-full"
      style={{
        background:
          'radial-gradient(farthest-side, #776e6e, #0000) top/8px 8px no-repeat, conic-gradient(#0000 50%, #776e6e)',
        WebkitMaskImage:
          'radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0)',
        maskImage:
          'radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0)',
        animation: 'spin 1s linear infinite',
      }}
    />
  </div>
)
